import { useEffect, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UISelectableButton from 'UIComponents/button/UISelectableButton';
import Small from 'UIComponents/elements/Small';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import getSalesPhoneNumber from 'ui-addon-upgrades/_core/common/adapters/getSalesPhoneNumber';
import { track } from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { StyledModal } from '../common/components/StyledModal';
import { MODAL_TYPES } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ReducedOptionsModal = ({
  handleIframeSizeChange = () => {},
  hideBackground = false,
  onClose,
  upgradeData,
  onModalView,
  onClickChat,
  onClickCall,
  modalRoot
}) => {
  const [isCallSectionVisible, setIsCallSectionVisible] = useState(false);
  useEffect(() => {
    onModalView();
  }, [onModalView]);
  const handleChatBackButtonClick = () => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'clicked unassignable phone back button'
    }, getUpgradeDataTrackingProperties(upgradeData)));
    handleIframeSizeChange(MODAL_TYPES.UNASSIGNABLE);
    setIsCallSectionVisible(false);
  };
  const handleClickCall = () => {
    onClickCall();
    handleIframeSizeChange(MODAL_TYPES.CALL_US);
    setIsCallSectionVisible(true);
  };
  const {
    phoneNumber,
    countryCode
  } = getSalesPhoneNumber();
  const optionalProps = modalRoot ? {
    rootNode: modalRoot
  } : {};
  return /*#__PURE__*/_jsxs(StyledModal, Object.assign({
    hideBackground: hideBackground,
    width: 550,
    use: "conversational",
    "data-test-id": isCallSectionVisible ? 'unassignable-selected-method-call' : 'unassignable-communication-methods-modal'
  }, optionalProps, {
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => onClose()
      }), /*#__PURE__*/_jsx(Text, {
        as: "h2",
        marginBlockEnd: "800",
        children: isCallSectionVisible ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.communicationMethods.callSales"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.communicationMethods.title"
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      paddingBlockEnd: "1000",
      children: isCallSectionVisible ? /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        "data-test-id": "communication-call-submit-success",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h4",
          margin: "0",
          children: phoneNumber
        }), countryCode && /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `SharedI18nStrings.countryCodes.${countryCode}`
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          className: "m-top-8",
          onClick: handleChatBackButtonClick,
          use: "link",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.communicationMethods.backButton"
          })
        })]
      }) : /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        justifyContent: "center",
        children: [/*#__PURE__*/_jsx(UISelectableButton, {
          "data-test-id": "unassignable-call",
          size: "large",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.communicationMethods.callUs"
          }),
          onClick: handleClickCall,
          children: /*#__PURE__*/_jsx(UIIllustration, {
            name: "calling-small",
            height: 75
          })
        }), /*#__PURE__*/_jsx(UISelectableButton, {
          "data-test-id": "unassignable-chat",
          selected: false,
          size: "large",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.communicationMethods.chatWithUs"
          }),
          onClick: () => onClickChat(),
          children: /*#__PURE__*/_jsx(UIIllustration, {
            name: "contacts-chat",
            height: 75
          })
        })]
      })
    })]
  }));
};